import { stringify } from "qs";

export class AppointmentClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/appointments`;
  }

  async list(params) {
    const url = this.baseURL;
    const data = params;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async postCreate(data) {
    const url = `${this.baseURL}/create`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async getNotices(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/notices${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postNoticesRead(data) {
    const url = `${this.baseURL}/notices/read`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async update(id, params) {
    const url = `${this.baseURL}/${id}/update`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async updateEmpty(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async putDate(id, params) {
    const url = `${this.baseURL}/${id}/date`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getReport(dateTime) {
    const queryString = stringify(dateTime, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/status/fulfilled/report${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async updateNote(id, params) {
    const url = `${this.baseURL}/${id}/note`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async putAppointmentReceipt(id, params) {
    const url = `${this.baseURL}/receipt/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async updateProviderAndActualCost(id, params) {
    const url = `${this.baseURL}/provider/actual_cost/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async postActionNote(data) {
    const url = `${this.baseURL}/create/action_note`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async getAppointmentNotices(id) {
    const url = `${this.baseURL}/notices/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getCountAppointmentRatingForAssignedAdmin(adminId) {
    const url = `${this.baseURL}/count/assign/${adminId}/admin`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAppointmentForRecreateSapByEditedProvider() {
    const url = `${this.baseURL}/sap/mm/recreate`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAppointmentProductWaitingConfirm(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/product/waiting/confirm${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async downloadReport(params) {
    const url = `${this.baseURL}/report`;

    const response = await this.httpClient.request("post", url, {
      data: params,
      responseType: "blob"
    });

    return response;
  }
}
